import SvgIcon from '@mui/material/SvgIcon';

export const CloudIdpIcon = () => (
  <SvgIcon
    width="500"
    height="500"
    viewBox="0 0 500 500"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M39.0392 178.204C47.9901 35.2676 204.434 -23.6263 306.853 40.6705"
      stroke="#479AAA"
      strokeOpacity="0.996078"
      strokeWidth="18.1191"
      strokeLinecap="round"
    />
    <path
      d="M35.8936 226.203V251.125V337.891H34.9942"
      stroke="#479AAA"
      strokeOpacity="0.996078"
      strokeWidth="18.1191"
      strokeLinecap="round"
    />
    <path
      d="M337.846 63.7272C385.179 113.872 389.869 145.643 393.45 194.918"
      stroke="#479AAA"
      strokeOpacity="0.996078"
      strokeWidth="18.1191"
      strokeLinecap="round"
    />
    <path
      d="M145.535 70.208C209.793 31.9016 344.149 58.6701 356.282 181.435"
      stroke="#479AAA"
      strokeOpacity="0.996078"
      strokeWidth="18.1191"
      strokeLinecap="round"
    />
    <path
      d="M110.183 238.458C98.9008 99.1363 187.946 74.2398 255.639 98.0741C272.657 104.066 290.506 116.952 302.278 131.593"
      stroke="#479AAA"
      strokeOpacity="0.996078"
      strokeWidth="18.1191"
      strokeLinecap="round"
    />
    <path
      d="M316.739 153.743C323.001 162.694 321.017 173.566 321.241 177.258"
      stroke="#479AAA"
      strokeOpacity="0.996078"
      strokeWidth="18.1191"
      strokeLinecap="round"
    />
    <path
      d="M143.048 248.615C143.048 231.908 142.711 216.058 142.767 211.788C145.234 87.079 280.314 127.408 280.314 177.874"
      stroke="#479AAA"
      strokeOpacity="0.996078"
      strokeWidth="18.1191"
      strokeLinecap="round"
    />
    <path
      d="M181.182 202.226C182.138 156.086 246.917 148.68 246.917 198.699"
      stroke="#479AAA"
      strokeOpacity="0.996078"
      strokeWidth="18.1191"
      strokeLinecap="round"
    />
    <path
      d="M74.9871 307.892C74.9871 210.511 60.1586 144.051 116.328 93.7457"
      stroke="#479AAA"
      strokeOpacity="0.996078"
      strokeWidth="18.1191"
      strokeLinecap="round"
    />
    <path
      d="M67.644 476.651L83.3713 454.959L88.7621 444.806"
      stroke="#479AAA"
      strokeOpacity="0.996078"
      strokeWidth="18.1191"
      strokeLinecap="round"
    />
    <path
      d="M107.245 485.307C120.276 467.308 120.276 466.846 120.276 466.846"
      stroke="#479AAA"
      strokeOpacity="0.996078"
      strokeWidth="18.1191"
      strokeLinecap="round"
    />
    <path
      d="M146.828 486.692L162.105 461.77"
      stroke="#479AAA"
      strokeOpacity="0.996078"
      strokeWidth="18.1191"
      strokeLinecap="round"
    />
    <path
      d="M293.83 165.274C269.805 165.293 246.282 171.581 226.002 183.403C205.722 195.225 189.522 212.095 179.29 232.046C168.418 225.817 155.763 222.503 142.834 222.499C124.959 222.501 107.817 228.824 95.178 240.076C82.5395 251.327 75.4396 266.587 75.4401 282.499C75.4547 285.164 75.6688 287.825 76.081 290.465C55.1415 297.982 37.2713 310.555 24.6943 326.618C12.1174 342.681 5.38908 361.526 5.34674 380.807C5.34603 393.717 8.34424 406.501 14.1702 418.428C19.9961 430.356 28.5357 441.193 39.3012 450.322C50.0668 459.451 62.8475 466.693 76.9137 471.633C90.9798 476.574 106.056 479.116 121.281 479.116C126.315 479.086 131.342 478.777 136.329 478.192H395.126V478.077C422.652 477.921 448.992 468.039 468.399 450.589C487.806 433.139 498.703 409.535 498.715 384.93C498.711 364.12 490.915 343.91 476.568 327.521C462.222 311.131 442.152 299.506 419.556 294.498C420.147 290.212 420.477 285.899 420.545 281.579C420.544 250.735 407.194 221.154 383.431 199.344C359.668 177.534 327.439 165.28 293.834 165.279L293.83 165.274Z"
      fill="#074565"
    />
    <path
      d="M110.198 416.326V282.269H137.265V416.326H110.198ZM163.053 282.269H212.524C223.68 282.269 232.184 283.122 238.037 284.829C245.901 287.146 252.637 291.261 258.246 297.174C263.854 303.088 268.122 310.342 271.048 318.938C273.974 327.473 275.437 338.019 275.437 350.578C275.437 361.612 274.066 371.122 271.322 379.108C267.969 388.862 263.184 396.757 256.966 402.792C252.271 407.364 245.931 410.931 237.945 413.491C231.971 415.381 223.985 416.326 213.987 416.326H163.053V282.269ZM190.12 304.947V393.739H210.329C217.888 393.739 223.345 393.313 226.698 392.459C231.087 391.362 234.714 389.502 237.579 386.881C240.506 384.26 242.883 379.962 244.712 373.987C246.541 367.952 247.455 359.753 247.455 349.389C247.455 339.025 246.541 331.07 244.712 325.522C242.883 319.974 240.323 315.646 237.031 312.537C233.739 309.428 229.563 307.325 224.503 306.227C220.723 305.374 213.316 304.947 202.282 304.947H190.12ZM298.481 416.326V282.269H341.917C358.377 282.269 369.106 282.94 374.105 284.281C381.787 286.292 388.218 290.682 393.4 297.449C398.582 304.155 401.173 312.842 401.173 323.51C401.173 331.74 399.679 338.659 396.692 344.268C393.705 349.877 389.895 354.296 385.262 357.527C380.689 360.697 376.026 362.801 371.271 363.837C364.809 365.117 355.451 365.757 343.197 365.757H325.549V416.326H298.481ZM325.549 304.947V342.988H340.363C351.031 342.988 358.164 342.287 361.76 340.885C365.357 339.482 368.162 337.288 370.173 334.301C372.246 331.313 373.282 327.839 373.282 323.876C373.282 318.999 371.85 314.975 368.985 311.805C366.119 308.635 362.492 306.654 358.103 305.861C354.872 305.252 348.379 304.947 338.625 304.947H325.549Z"
      fill="white"
    />
    <path
      d="M244.888 254.288L250.857 255.796C249.606 260.699 247.349 264.443 244.088 267.027C240.846 269.592 236.877 270.874 232.179 270.874C227.318 270.874 223.359 269.889 220.302 267.92C217.266 265.93 214.948 263.058 213.348 259.304C211.768 255.55 210.979 251.519 210.979 247.211C210.979 242.514 211.871 238.421 213.656 234.934C215.461 231.426 218.015 228.769 221.317 226.964C224.641 225.138 228.292 224.226 232.272 224.226C236.785 224.226 240.58 225.374 243.657 227.672C246.734 229.969 248.878 233.2 250.088 237.365L244.211 238.749C243.165 235.467 241.647 233.077 239.657 231.58C237.667 230.082 235.164 229.333 232.149 229.333C228.682 229.333 225.779 230.164 223.441 231.826C221.123 233.487 219.492 235.723 218.548 238.534C217.604 241.324 217.133 244.206 217.133 247.18C217.133 251.016 217.687 254.37 218.794 257.242C219.923 260.094 221.666 262.227 224.025 263.643C226.384 265.058 228.938 265.766 231.687 265.766C235.031 265.766 237.862 264.802 240.18 262.873C242.498 260.945 244.067 258.083 244.888 254.288ZM257.411 270.104V224.995H262.95V270.104H257.411ZM269.504 253.765C269.504 247.714 271.186 243.231 274.55 240.319C277.361 237.898 280.787 236.688 284.828 236.688C289.32 236.688 292.992 238.165 295.844 241.119C298.695 244.052 300.121 248.114 300.121 253.304C300.121 257.509 299.485 260.822 298.213 263.243C296.962 265.643 295.126 267.509 292.705 268.843C290.305 270.176 287.679 270.843 284.828 270.843C280.253 270.843 276.55 269.376 273.72 266.443C270.909 263.509 269.504 259.283 269.504 253.765ZM275.197 253.765C275.197 257.95 276.109 261.089 277.935 263.181C279.761 265.253 282.058 266.289 284.828 266.289C287.577 266.289 289.864 265.243 291.69 263.15C293.515 261.058 294.428 257.868 294.428 253.581C294.428 249.539 293.505 246.483 291.659 244.411C289.833 242.319 287.556 241.272 284.828 241.272C282.058 241.272 279.761 242.308 277.935 244.38C276.109 246.452 275.197 249.58 275.197 253.765ZM328.06 270.104V265.304C325.517 268.997 322.06 270.843 317.691 270.843C315.762 270.843 313.957 270.474 312.275 269.735C310.613 268.997 309.372 268.074 308.552 266.966C307.752 265.838 307.188 264.463 306.859 262.843C306.634 261.755 306.521 260.032 306.521 257.673V237.426H312.06V255.55C312.06 258.442 312.172 260.391 312.398 261.396C312.747 262.853 313.485 264.002 314.614 264.843C315.742 265.663 317.137 266.073 318.798 266.073C320.46 266.073 322.019 265.653 323.475 264.812C324.932 263.95 325.958 262.791 326.553 261.335C327.168 259.858 327.476 257.724 327.476 254.935V237.426H333.014V270.104H328.06ZM362.923 270.104V265.981C360.851 269.222 357.805 270.843 353.784 270.843C351.179 270.843 348.779 270.125 346.584 268.689C344.41 267.253 342.717 265.253 341.507 262.689C340.317 260.104 339.722 257.14 339.722 253.796C339.722 250.534 340.266 247.58 341.353 244.934C342.44 242.267 344.071 240.226 346.246 238.811C348.42 237.395 350.851 236.688 353.538 236.688C355.508 236.688 357.261 237.108 358.8 237.949C360.339 238.77 361.59 239.847 362.554 241.18V224.995H368.062V270.104H362.923ZM345.415 253.796C345.415 257.981 346.297 261.109 348.061 263.181C349.825 265.253 351.907 266.289 354.308 266.289C356.728 266.289 358.779 265.304 360.462 263.335C362.164 261.345 363.016 258.319 363.016 254.258C363.016 249.786 362.154 246.503 360.431 244.411C358.708 242.319 356.585 241.272 354.061 241.272C351.6 241.272 349.538 242.278 347.876 244.288C346.235 246.298 345.415 249.468 345.415 253.796Z"
      fill="white"
    />
  </SvgIcon>
);
